import type { IconGlyph } from '../icon';

/**
 * Tractie `radar-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/radar-thick.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconRadarThick: IconGlyph = {
  name: 'radar-thick',
  path: 'M19.86 4.33a.996.996 0 1 0-1.42 1.4 8.97 8.97 0 0 1 2.57 6.3c0 4.97-4.03 9-9 9S3 17 3 12.03c0-4.64 3.5-8.45 8-8.95v1.01c-3.95.49-7 3.86-7 7.94 0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.18-.87-4.16-2.29-5.6a.996.996 0 1 0-1.42 1.4A6.005 6.005 0 0 1 12 18.03c-3.31 0-6-2.69-6-6 0-2.97 2.16-5.44 5-5.92v1.02a5 5 0 1 0 4.57 1.4.996.996 0 1 0-1.42 1.4 2.996 2.996 0 0 1-2.14 5.1c-1.66 0-3-1.34-3-3 0-1.31.83-2.42 2-2.83v2.83c0 .55.45 1 1 1s1-.45 1-1V2.12c0-.61-.5-1.1-1.11-1.09C5.87 1.08 1 5.99 1 12.03s4.92 11 11 11 11-4.92 11-11c0-3-1.2-5.72-3.14-7.7',
};
